<div>
  <span>{{ text }}</span>
</div>
